export default __webpack_public_path__ + "static/media/profile.02a38eaf.png";